import React, { useEffect, Fragment, useCallback, useState } from 'react';
import {
    Row,
    Col,
    Card,
    ListGroup,
    ListGroupItem,
    Container,
    UncontrolledButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalHeader,
    ModalBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input
} from 'reactstrap';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ModalAssignToVolunteer from '../../../../../Layout/AppMain/ModalAssignToVolunteer';
import ModalEditInfo from '../../../../../Layout/AppMain/ModalEditInfo';

import UserRelationGroupStatuses from '../../../../../enums/UserRelationGroupStatuses';
import UserRoles from '../../../../../enums/UserRoles';
import FilterStatuses from '../../../../../enums/FilterStatuses';
import api from '../../../../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../Context/Auth/AuthContext';
import InputMask from 'react-input-mask';
import UserStatuses from '../../../../../enums/UserStatuses';

export default function ReceiversList({
    id,
    activeTab,
    filter,
    newUser
}) {
    const [receiversData, setReceiversData] = useState([]);
    const [groupId, setGroupId] = useState(null);
    const { toggleLoading } = useAuth();
    const [newEmail, setNewEmail] = useState();

    const [currentMember, setCurrentMember] = useState(null);
    const [modalInactive, setModalInactive] = useState(false);
    const toggleModalInactive = useCallback((member = null) => {
        setCurrentMember(member);
        setModalInactive(!modalInactive);
    }, [setCurrentMember, setModalInactive, modalInactive]);

    const [modalActive, setModalActive] = useState(false);
    const toggleModalActive = useCallback((member = null) => {
        setCurrentMember(member);
        setModalActive(!modalActive);
    }, [setCurrentMember, setModalActive, modalActive]);

    const [modalRemove, setModalRemove] = useState(false);
    const toggleModalRemove = useCallback((member = null) => {
        setCurrentMember(member);
        setModalRemove(!modalRemove);
    }, [setCurrentMember, setModalRemove, modalRemove]);

    const [modalEditInfo, setModalEditInfo] = useState(false);
    const toggleModalEditInfo = useCallback((member = null) => {
        setCurrentMember(member);
        setModalEditInfo(!modalEditInfo)
    }, [setModalEditInfo, modalEditInfo]);

    const [modalEditEmail, setModalEditEmail] = useState(false);
    const toggleModalEditEmail = useCallback((member = null) => {
        setCurrentMember(member);
        setModalEditEmail(!modalEditEmail)
    }, [setModalEditEmail, modalEditEmail]);

    const [lastId, setLastId] = useState(null);

    const loadReceivers = useCallback(() => {
        toggleLoading(true);
        setGroupId(id.id);
        api.post(`/ro.team.listReceiversGroup/${id.id}`)
            .then((response) => {
                console.log(response)
                setReceiversData(response.data.items);
                setLastId(response.data.lastId);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [id, toggleLoading, setGroupId, setLastId]);

    const loadMore = useCallback(() => {
        toggleLoading(true);
        setGroupId(id.id);
        api.post(`/ro.team.listReceiversGroup/${id.id}`, { lastId })
            .then((response) => {
                setReceiversData([...receiversData, ...response.data.items]);
                setLastId(response.data.lastId);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [toggleLoading, receiversData, id, setGroupId, lastId, setLastId]);

    useEffect(() => {
        if (activeTab === UserRoles.RECEIVER.toString()) {
            loadReceivers();
        }
        if (newUser === UserRoles.RECEIVER.toString()) {
            loadReceivers();
        }
    }, [activeTab, id, newUser, toggleLoading, loadReceivers]);

    const check = (member) => {
        if (filter.id === '') {
            return true;
        }

        if (
            filter.id === FilterStatuses[0].id &&
            (member.status.code === UserRelationGroupStatuses.ACCEPTED_BY_PARENT ||
                member.status.code === UserRelationGroupStatuses.ACCEPTED_BY_CHILD ||
                member.status.code === UserRelationGroupStatuses.INVITED_BY_PARENT)
        ) {
            return true;
        }

        if (
            filter.id === FilterStatuses[2].id &&
            (member.status.code ===
                UserRelationGroupStatuses.ACCEPTED_BY_PARENT ||
                member.status.code ===
                    UserRelationGroupStatuses.ACCEPTED_BY_CHILD)
        ) {
            return true;
        }

        if (
            filter.id === FilterStatuses[3].id &&
            (
                member.status.code ===
                    UserRelationGroupStatuses.INVITED_BY_PARENT)
        ) {
            return true;
        }

        if (
            filter.id === FilterStatuses[1].id &&
            member.status.code === UserRelationGroupStatuses.SUSPENDED
        ) {
            return true;
        }

        if (
            filter.id === FilterStatuses[4].id &&
            (member.status.code ===
                UserRelationGroupStatuses.REJECTED_BY_CHILD)
        ) {
            return true;
        }

        if (filter.id === FilterStatuses[5].id && (member.status.code === UserRelationGroupStatuses.REQUESTED_BY_CHILD)){
            return true;
        }

        if (filter.id === FilterStatuses[6].id && (member.status.code === UserRelationGroupStatuses.REJECTED_BY_PARENT)){
            return true;
        }

        if (filter.id === 'ASSIGNED' && member.givers.length > 0) {
            return true;
        }

        if (filter.id === 'NOT ASSIGNED' && member.givers.length === 0) {
            return true;
        }
    };

    const [modalAssignToVolunteer, setModalAssignToVolunteer] = useState(false);
    const [receiverToAssign, setReceiverToAssign] = useState({});
    const toggleModalAssignToVolunteer = useCallback(() => {
        setModalAssignToVolunteer(!modalAssignToVolunteer);
    }, [modalAssignToVolunteer, setModalAssignToVolunteer]);

    const inactiveMember = useCallback(
        (member) => {
            toggleLoading(true);
            api.patch(`/ro.team.inactivateMember/${id.id}`, {
                type: UserRoles.RECEIVER,
                idMember: member.id,
            })
                .then(() => {
                    toast.success(`${member.name} is marked as inactive`);
                    toggleModalInactive(null);
                    loadReceivers();
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        },
        [id, toggleLoading, toggleModalInactive, loadReceivers]
    );

    const activeMember = useCallback(
        (member) => {
            toggleLoading(true);
            api.patch(`/ro.team.activateMember/${id.id}`, {
                type: UserRoles.RECEIVER,
                idMember: member.id,
            })
                .then(() => {
                    toast.success(`${member.name} is marked as active`);
                    toggleModalActive(null);
                    loadReceivers();
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        },
        [id, toggleLoading, toggleModalActive, loadReceivers]
    );

    const removeMember = useCallback(
        (member) => {
            toggleLoading(true);
            api.patch(`/ro.team.removeMember/${id.id}`, {
                type: UserRoles.RECEIVER,
                idMember: member.id,
            })
                .then((response) => {
                    toast.success(`${member.name} was removed!`);
                    toggleModalRemove(null);
                    loadReceivers();
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        },
        [id, toggleLoading, toggleModalRemove, loadReceivers]
    );

    const changeEmail = useCallback(
        (member, newEmail) => {
            if (!newEmail || newEmail === '') {
                toast.error('Insert a valid email');
                return;
            }
            toggleLoading(true);
            api.patch(`/ro.team.changeUserEmail/${id.id}`, {
                type: UserRoles.RECEIVER,
                idMember: member.id,
                newEmail: newEmail
            })
                .then((response) => {
                    toast.success(`Senior email changed!`);
                    toggleModalEditEmail(null);
                    setNewEmail();
                    loadReceivers();
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        },
        [id, toggleLoading, toggleModalEditEmail, loadReceivers, setNewEmail]
    );

    const checkAcceptedStatus = useCallback((status) => {
        if (status === UserRelationGroupStatuses.ACCEPTED_BY_PARENT || status === UserRelationGroupStatuses.ACCEPTED_BY_CHILD) {
            return true;
        }
        return false;
    }, []);

    const checkPendingStatus = useCallback((status) => {
        if (status === UserStatuses.PENDING) {
            return true;
        }
        return false;
    }, []);

    const checkIsAssigned = useCallback((member) => {
        if (member.givers.length && member.givers.length > 0) {
            return true;
        } else {
            return false;
        }
    }, []);

    const showReceiverEmail = useCallback((email) => {
        if (email.includes('@noemail.com')) {
            return `No email`;
        } else {
            return email;
        }
    }, []);

    const noEmail = useCallback((email) => {
        if (email.includes('@noemail.com')) {
            return true;
        } else {
            return false;
        }
    }, []);

    const acceptMember = useCallback((member) => {
        toggleLoading(true);
        api.post(`/ro.team.acceptMember/${id.id}`, {
            idMember: member.id
        })
            .then(() => {
                toast.success(`${member.name} has been added!`);
                loadReceivers();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [toggleLoading, id, loadReceivers]);

    const refuseMember = useCallback((member) => {
        toggleLoading(true);
        api.post(`/ro.team.refuseMember/${id.id}`, {
            idMember: member.id
        })
            .then(() => {
                toast.success(`${member.name} has been refused!`);
                loadReceivers();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [toggleLoading, id, loadReceivers]);

    const checkRequestChildRejectedParent = useCallback((status) => {
        if (status === UserRelationGroupStatuses.REQUESTED_BY_CHILD || status === UserRelationGroupStatuses.REJECTED_BY_PARENT) {
            return true;
        }
        return false;
    }, []);

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col lg="12">
                        <Card className="main-card mb-3">
                            <ListGroup flush className="users-list">
                                {receiversData &&
                                    receiversData.map(
                                        (member) =>
                                            check(member) && (
                                                <ListGroupItem key={member.id}>
                                                    <div className="widget-content p-0">
                                                        <div className="widget-content-wrapper">
                                                            <div className="widget-content-left mr-3">
                                                                <div className="placeholder-avatar">
                                                                    {member.name
                                                                        ? member.name.charAt(
                                                                              0
                                                                          )
                                                                        : member.email.charAt(
                                                                              0
                                                                          )}
                                                                </div>
                                                            </div>
                                                            <div className="widget-content-left">
                                                                <div className="widget-heading">
                                                                    {member.name &&
                                                                        member.name}
                                                                </div>
                                                                {member.givers.length > 0 && (
                                                                    <div className="widget-subheading">
                                                                        <u>Volunteer</u>: {member.givers[0].name}
                                                                    </div>
                                                                )}

                                                                {!noEmail(member.email) && (
                                                                    <div className="widget-subheading">
                                                                        { showReceiverEmail(member.email) }
                                                                    </div>
                                                                )}
                                                                {noEmail(member.email) && (
                                                                    <div
                                                                        className="widget-subheading hover-cursor-pointer"
                                                                        onClick={() => {
                                                                            toggleModalEditEmail(member);
                                                                        }}
                                                                    >
                                                                        { showReceiverEmail(member.email) }
                                                                    </div>
                                                                )}

                                                                <div className="widget-subheading">
                                                                    {member.phone && (
                                                                        <InputMask
                                                                            mask="(999) 999-9999"
                                                                            disabled={true}
                                                                            value={member.phone}
                                                                            className="textInputChange"
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="widget-content-right">
                                                                {member.status.code === UserRelationGroupStatuses.SUSPENDED && (
                                                                    <div className="mb-2 mr-2 badge badge-warning">
                                                                        Inactive
                                                                    </div>
                                                                )}

                                                                {member.status.code === UserRelationGroupStatuses.REJECTED_BY_CHILD && (
                                                                    <div className="mb-2 mr-2 badge badge-warning">
                                                                        Declined
                                                                    </div>
                                                                )}

                                                                {member.status.code === UserRelationGroupStatuses.REJECTED_BY_PARENT && (
                                                                    <div className="mb-2 mr-2 badge badge-danger">
                                                                        Refused
                                                                    </div>
                                                                )}

                                                                {member.status.code === UserRelationGroupStatuses.INVITED_BY_PARENT && (
                                                                    <div className="mb-2 mr-2 badge badge-warning">
                                                                        Waiting for acceptance
                                                                    </div>
                                                                )}

                                                                {member.status.code === UserRelationGroupStatuses.REQUESTED_BY_CHILD && (
                                                                    <div className="mb-2 mr-2 badge badge-warning">
                                                                        Requested to Join
                                                                    </div>
                                                                )}

                                                                <Fragment>
                                                                    <UncontrolledButtonDropdown direction="left">
                                                                        <DropdownToggle color="primary">
                                                                            <FontAwesomeIcon
                                                                                icon={
                                                                                    faBars
                                                                                }
                                                                                size="1x"
                                                                            />
                                                                        </DropdownToggle>
                                                                        <DropdownMenu className="no-arrow">
                                                                            <DropdownItem
                                                                                header
                                                                            >
                                                                                Actions
                                                                            </DropdownItem>
                                                                            <DropdownItem
                                                                                divider
                                                                            />
                                                                            {checkAcceptedStatus(member.status.code) && (
                                                                                <div>
                                                                                    <DropdownItem
                                                                                        onClick={() => {
                                                                                            setReceiverToAssign(
                                                                                                member
                                                                                            );
                                                                                            toggleModalAssignToVolunteer();
                                                                                        }}
                                                                                    >
                                                                                        {!checkIsAssigned(member) && (
                                                                                            <Fragment>Assign to Volunteer</Fragment>
                                                                                        )}
                                                                                        {checkIsAssigned(member) && (
                                                                                            <Fragment>Change Assignment</Fragment>
                                                                                        )}
                                                                                    </DropdownItem>
                                                                                    {checkPendingStatus(member.userstatus.code) && (
                                                                                        <DropdownItem
                                                                                            onClick={() => {
                                                                                                toggleModalEditInfo(member);
                                                                                            }}
                                                                                        >
                                                                                            Edit info
                                                                                        </DropdownItem>
                                                                                    )}
                                                                                    
                                                                                </div>
                                                                            )}
                                                                            {checkRequestChildRejectedParent(member.status.code) && (
                                                                                <DropdownItem
                                                                                    onClick={() => {
                                                                                        acceptMember(member);
                                                                                    }}
                                                                                >
                                                                                    Accept Member
                                                                                </DropdownItem>
                                                                            )}
                                                                            {member.status.code === UserRelationGroupStatuses.REQUESTED_BY_CHILD && (
                                                                                <DropdownItem
                                                                                    onClick={() => {
                                                                                        refuseMember(member);
                                                                                    }}
                                                                                >
                                                                                    Refuse Member
                                                                                </DropdownItem>
                                                                            )}

                                                                            {member.status.code !== UserRelationGroupStatuses.SUSPENDED &&
                                                                            member.status.code !== UserRelationGroupStatuses.REQUESTED_BY_CHILD && (
                                                                                <DropdownItem
                                                                                    onClick={() => {
                                                                                        toggleModalInactive(member);
                                                                                    }}
                                                                                >
                                                                                    Mark as Inactive
                                                                                </DropdownItem>
                                                                            )}
                                                                            {member.status.code === UserRelationGroupStatuses.SUSPENDED && (
                                                                                <DropdownItem
                                                                                    onClick={() => {
                                                                                        toggleModalActive(member);
                                                                                    }}
                                                                                >
                                                                                    Mark as Active
                                                                                </DropdownItem>
                                                                            )}
                                                                            <DropdownItem
                                                                                onClick={() => {
                                                                                    toggleModalRemove(member);
                                                                                }}
                                                                            >
                                                                                Remove
                                                                                Senior
                                                                            </DropdownItem>
                                                                            {/* {checkAcceptedStatus(member.status.code) && (
                                                                                <DropdownItem>
                                                                                    View Needs
                                                                                </DropdownItem>
                                                                            )} */}
                                                                        </DropdownMenu>
                                                                    </UncontrolledButtonDropdown>
                                                                </Fragment>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ListGroupItem>
                                            )
                                    )}
                            </ListGroup>
                        </Card>

                        {lastId !== null && (
                            <div className="text-center">
                                <Button
                                    className="btn-wide mb-2 mr-2"
                                    size="md"
                                    color="info"
                                    onClick={loadMore}
                                >
                                    Load more
                                </Button>
                            </div>
                        )}

                    </Col>
                </Row>

                <Modal isOpen={modalRemove} toggle={toggleModalRemove}>
                    <ModalHeader toggle={toggleModalRemove}>
                        Confirm remove Senior
                    </ModalHeader>
                    <ModalBody>
                        <div className="text-center">
                            <p>Do you really want to remove Senior?</p>
                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="danger"
                                onClick={() => {
                                    removeMember(currentMember);
                                }}
                            >
                                Remove
                            </Button>

                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="secondary"
                                onClick={toggleModalRemove}
                            >
                                Cancel
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={modalInactive} toggle={toggleModalInactive}>
                    <ModalHeader toggle={toggleModalInactive}>
                        Confirm Inactive Senior
                    </ModalHeader>
                    <ModalBody>
                        <div className="text-center">
                            <p>Do you really want to inactivate Senior?</p>
                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="danger"
                                onClick={() => {
                                    inactiveMember(currentMember);
                                }}
                            >
                                Inactive
                            </Button>

                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="secondary"
                                onClick={toggleModalInactive}
                            >
                                Cancel
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={modalActive} toggle={toggleModalActive}>
                    <ModalHeader toggle={toggleModalActive}>
                        Confirm Active Senior
                    </ModalHeader>
                    <ModalBody>
                        <div className="text-center">
                            <p>Do you really want to activate Senior?</p>
                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="info"
                                onClick={() => {
                                    activeMember(currentMember);
                                }}
                            >
                                Active
                            </Button>

                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="secondary"
                                onClick={toggleModalActive}
                            >
                                Cancel
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={modalEditEmail} toggle={toggleModalEditEmail}>
                    <ModalHeader toggle={toggleModalEditEmail}>
                        Define Senior Email
                    </ModalHeader>
                    <ModalBody>
                        <div className="text-center">
                            <Form>
                                <FormGroup row>
                                    <Col sm={{size: 8, offset: 2}}>
                                        <Label>Enter the Senior email</Label>
                                        <Input
                                            type="email"
                                            onChange={(e) => {
                                                setNewEmail(e.target.value);
                                            }}
                                        />
                                    </Col>
                                </FormGroup>
                            </Form>
                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="info"
                                onClick={() => {
                                    changeEmail(currentMember, newEmail);
                                }}
                            >
                                Change
                            </Button>

                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="secondary"
                                onClick={toggleModalEditEmail}
                            >
                                Cancel
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>

            </Container>
            <ModalAssignToVolunteer
                modal={modalAssignToVolunteer}
                toggleModal={toggleModalAssignToVolunteer}
                receiver={receiverToAssign}
                groupId={groupId}
                isModalOpen={modalAssignToVolunteer}
                receivers={receiversData}
                loadCallback={loadReceivers}
            />
            <ModalEditInfo
                modalEditInfo={modalEditInfo}
                toggleModalEditInfo={toggleModalEditInfo}
                id={id}
                loadCallback={loadReceivers}
                member={currentMember}
            />
        </Fragment>
    );
}
